<script lang="ts">
	import type { Snippet } from 'svelte';
	import type { SpecCardTypeWithBlock } from '../types';
	import Card from '$lib/components/route/routeSelector/components/Card.svelte';

	interface Props {
		list: SpecCardTypeWithBlock[];
		dataTestId?: string;
		children?: Snippet;
	}

	const { list, dataTestId, children }: Props = $props();
</script>
<div class="route-spec-card grid grid-cols-2 gap-2 pb-2" data-testid={dataTestId}>
	{#each list as item, index (item.type)}
		{#if item.title || item.buttonLabel}
			<div class={['h-full', index === 2 && 'grid-col-[1/-1]']}>
				<Card
					dataTestId={`${item.type}-card`}
					class={[
						'pt-3! px-3 pb-1 text-coloredneutral h-full',
						// NOTE: This is a hack to position button and definition list on the same line for the third card
						index === 2 && 'flex [div:nth-of-type(2n)>&]:flex-col! justify-between pb-3 items-center',
					]}>
					{@render item.blockName(item)}
				</Card>
			</div>
		{/if}
	{/each}
	{@render children?.()}
</div>
<style>
	.route-spec-card div {
		/* This CSS rule selects every div inside the element .route-spec-card that is at a position which is a multiple of 3, excluding the second-to-last one. */
		&:nth-of-type(3n + 3):not(:nth-last-child(2)),
		&:nth-of-type(3n + 3):not(:nth-last-child(3)) {
			--uno: col-span-2;
			& :global(.definition-item) {
				--uno: mb-0;
			}

			& :global(.roadsheet-title) {
				--uno: hidden;
			}
		}
	}
</style>
